import React from 'react';
import PropTypes from 'prop-types';

import hoistNonReactStatics from 'hoist-non-react-statics';

import {setActiveMainTaxon} from '../../ducks/ui';

export default (processLocation) => WrappedComponent => hoistNonReactStatics(
  class SyncLocation extends React.Component {
    syncLocation = (props) => {
      const {dispatch} = props;

      const activeMainTaxon = processLocation(props);

      if (activeMainTaxon) {
        dispatch(setActiveMainTaxon(activeMainTaxon));
      }
    };

    componentDidMount() {
      this.syncLocation(this.props);
    }

    componentDidUpdate() {
      this.syncLocation(this.props);
    }

    render() {
      return <WrappedComponent {...this.props}/>
    }
  },
  WrappedComponent
);



// WEBPACK FOOTER //
// ./containers/syncLocation/syncLocation.js